import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';

function AccessSubsidizedNSH() {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [providers, setProviders] = useState(null);



  useEffect(() => {
    setError(null);

    // Instantiate a new server to define where the RDS API is hosted.
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

    // TODO: change query
    function getCapacity() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'provider');

      const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND license_type=LIC and operating_during_nsh=1`;

      return rdsTabulate('ccdc', 'provider', {
        dims: 'state_fips',
        measure: 'count:COUNT(*)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    setReady(false);
    setError(null);
    Promise.all([getCapacity()])
      .then((responses) => {
        if (responses[0].parsedBody.dataProvider.length > 0) {
          setProviders(responses[0].parsedBody.dataProvider[0].count);
        } else {
          setProviders(null);
        }
      })
      .catch((rdsError) => {
        // console.error(rdsError);
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return (
      <CircularProgress />
    );
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      {providers && (
        <Typography variant="body1" align="left">
          In <b>{states[stateCode.toUpperCase()]}</b>, <b>{toFormattedNumber(providers)}</b> providers offer NSH care.  Access to NSH care varies by setting type and quality rating.
        </Typography>
      )}

      {!providers && (
        <Typography variant="body1" align="left">
          Not reported
        </Typography>
      )}
    </>
  );
}

export default AccessSubsidizedNSH;
